import React from 'react';
import ModernNavigation from './ModernNavigation';

interface ModernLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

const ModernLayout: React.FC<ModernLayoutProps> = ({ 
  children, 
  title, 
  subtitle, 
  actions 
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ModernNavigation />
      
      {/* Main Content */}
      <main className="lg:ml-64">
        {/* Page Header */}
        {(title || subtitle || actions) && (
          <div className="bg-white border-b border-gray-200 px-6 py-8">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between">
                <div>
                  {title && (
                    <h1 className="text-3xl font-bold text-gray-900 font-display">
                      {title}
                    </h1>
                  )}
                  {subtitle && (
                    <p className="mt-2 text-lg text-gray-600 font-body">
                      {subtitle}
                    </p>
                  )}
                </div>
                {actions && (
                  <div className="flex items-center space-x-3">
                    {actions}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {/* Page Content */}
        <div className="px-6 py-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ModernLayout;
